"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plans = void 0;
exports.Plans = {
    create: (_features, _limits, plans) => {
        const explicitOrderedIDs = Object.values(plans).map((plan) => plan.ID);
        return {
            ...plans,
            whichPlansCan: (test) => {
                return Object.values(plans).filter((plan) => {
                    return plan.can(test) && plan.VISIBLE;
                });
            },
            getAllPlans: () => {
                return Object.values(plans);
            },
            isValidPlanID: (planId) => {
                return Object.values(plans).some((plan) => plan.ID === planId);
            },
            findById: (planId) => {
                return Object.values(plans).find((plan) => plan.ID === planId);
            },
            downgradePlansOf: (planId) => {
                const planIndex = explicitOrderedIDs.indexOf(planId);
                if (planIndex === -1) {
                    return [];
                }
                const idsBeforeIndex = explicitOrderedIDs.slice(0, planIndex);
                return Object.values(plans).filter((plan) => {
                    return idsBeforeIndex.includes(plan.ID);
                });
            },
            upgradePlansOf: (planId) => {
                const planIndex = explicitOrderedIDs.indexOf(planId);
                if (planIndex === -1) {
                    return [];
                }
                const idsAfterIndex = explicitOrderedIDs.slice(planIndex + 1);
                return Object.values(plans).filter((plan) => {
                    return idsAfterIndex.includes(plan.ID);
                });
            },
            idsToNames: (planIds) => {
                return planIds.map((planId) => {
                    var _a;
                    return (((_a = Object.values(plans).find((plan) => plan.ID === planId)) === null || _a === void 0 ? void 0 : _a.NAME) ||
                        'Unknown Plan');
                });
            },
        };
    },
};
